/**
 * static/js/utils/mobile-sheet.js
 *
 * Augments native <dialog> elements with the conventions we want everywhere:
 *   1. Backdrop tap closes the dialog (native <dialog> doesn't do this by default).
 *   2. Optional body-lock integration (disables underlying page scroll while open;
 *      requires JN.bodyLock to be loaded — a no-op otherwise).
 *
 * Extracts the inline pattern shipped on monitor.html (see Engineering wiki:
 * Mobile UI/UX Remediation, "Group F" deferred items in MOBILE_AUDIT.md PR 1.6)
 * into a reusable opener so other surfaces can opt in with one line.
 *
 * Loaded per-page (not in base.html). Idempotent — safe to call wireUp() multiple times.
 *
 * Usage:
 *   JN.mobileSheet.wireUp();                    // every <dialog.mobile-sheet>
 *   JN.mobileSheet.wireUp('dialog');            // every <dialog>
 *   JN.mobileSheet.wireOne(myDialog, { lockBody: false });
 *   JN.mobileSheet.autoWire();                  // wireUp() on DOMContentLoaded
 *
 * Refs #3886 (Mobile UI/UX Phase 2 PR 2.1), #3842 (origin in monitor.html).
 */
(function (window, document) {
  'use strict';

  var WIRED_KEY = '__jn_mobile_sheet_wired';

  function wireOne(dialog, options) {
    if (!dialog || dialog[WIRED_KEY]) return;
    dialog[WIRED_KEY] = true;
    options = options || {};

    // Backdrop tap closes the dialog. Click on the dialog backdrop (not its
    // children) bubbles with e.target === dialog because <dialog> + ::backdrop
    // share a layout box.
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });

    // Body-lock integration. Requires body-lock.js to be loaded; otherwise no-op.
    if (options.lockBody !== false && window.JN && window.JN.bodyLock) {
      var locked = false;
      var observer = new MutationObserver(function () {
        if (dialog.open && !locked) { window.JN.bodyLock.lock(); locked = true; }
        else if (!dialog.open && locked) { window.JN.bodyLock.unlock(); locked = false; }
      });
      observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
      // Catch already-open dialogs at wire time.
      if (dialog.open) { window.JN.bodyLock.lock(); locked = true; }
    }
  }

  function wireUp(selector, options) {
    document.querySelectorAll(selector || 'dialog.mobile-sheet').forEach(function (d) {
      wireOne(d, options);
    });
  }

  function autoWire(selector, options) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { wireUp(selector, options); });
    } else {
      wireUp(selector, options);
    }
  }

  window.JN = window.JN || {};
  window.JN.mobileSheet = {
    wireOne: wireOne,
    wireUp: wireUp,
    autoWire: autoWire,
  };
})(window, document);
